module.exports = __webpack_public_path__ + "img/bj8.f7a79e15.png";